<template>
  <div class="screw-body">
    <div class="screw-body-inner">
      <div class="screw-body-inner-left">
        <div class="screw-left-logo"></div>
        <div class="screw-left-body">
          <div class="screw-left-main10">
            <div ref="pieTen" style="width: 100%; height: 18vh"></div>
          </div>
          <div class="screw-left-main8">
            <div ref="pieEight" style="width: 100%; height: 18vh"></div>
          </div>
          <div class="screw-left-main6">
            <div ref="pieSix" style="width: 100%; height: 18vh"></div>
          </div>
          <div class="screw-left-main4">
            <div ref="pieFour" style="width: 100%; height: 18vh"></div>
          </div>
          <div class="screw-left-main2">
            <div ref="pieTwo" style="width: 100%; height: 17vh"></div>
          </div>
        </div>
      </div>
      <div class="screw-body-inner-center">
        <div class="screw-center-tit">
          F11 <span style="color: #28A1FE;">------</span>
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b11.value == 0" @click="switchBeng(11, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b11.value == 1" @click="switchBeng(11, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b11.value == 0" @click="switchKong(11, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b11.value == 1" @click="switchKong(11, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b11.value == 0" @click="switchModel(11, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b11.value == 1" @click="switchModel(11, 0)">制热 ☀</div>
        </div>
        <div class="screw-center-titL">
          <span style="color: #28A1FE;">------</span> F10
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b10.value == 0" @click="switchBeng(10, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b10.value == 1" @click="switchBeng(10, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b10.value == 0" @click="switchKong(10, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b10.value == 1" @click="switchKong(10, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b10.value == 0" @click="switchModel(10, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b10.value == 1" @click="switchModel(10, 0)">制热 ☀</div>
        </div>
        <div class="screw-center-tit">
          F9 <span style="color: #28A1FE;">------</span>
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b09.value == 0" @click="switchBeng(9, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b09.value == 1" @click="switchBeng(9, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b09.value == 0" @click="switchKong(9, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b09.value == 1" @click="switchKong(9, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b09.value == 0" @click="switchModel(9, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b09.value == 1" @click="switchModel(9, 0)">制热 ☀</div>
        </div>
        <div class="screw-center-titL">
          <span style="color: #28A1FE;">------</span> F8
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b08.value == 0" @click="switchBeng(8, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b08.value == 1" @click="switchBeng(8, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b08.value == 0" @click="switchKong(8, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b08.value == 1" @click="switchKong(8, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b08.value == 0" @click="switchModel(8, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b08.value == 1" @click="switchModel(8, 0)">制热 ☀</div>

        </div>
        <div class="screw-center-tit">
          F7 <span style="color: #28A1FE;">------</span>
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b07.value == 0" @click="switchBeng(7, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b07.value == 1" @click="switchBeng(7, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b07.value == 0" @click="switchKong(7, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b07.value == 1" @click="switchKong(7, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b07.value == 0" @click="switchModel(7, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b07.value == 1" @click="switchModel(7, 0)">制热 ☀</div>
        </div>
        <div class="screw-center-titL">
          <span style="color: #28A1FE;">------</span> F6
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b06.value == 0" @click="switchBeng(6, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b06.value == 1" @click="switchBeng(6, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b06.value == 0" @click="switchKong(6, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b06.value == 1" @click="switchKong(6, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b06.value == 0" @click="switchModel(6, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b06.value == 1" @click="switchModel(6, 0)">制热 ☀</div>

        </div>
        <div class="screw-center-tit">
          F5 <span style="color: #28A1FE;">------</span>
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b05.value == 0" @click="switchBeng(5, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b05.value == 1" @click="switchBeng(5, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b05.value == 0" @click="switchKong(5, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b05.value == 1" @click="switchKong(5, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b05.value == 0" @click="switchModel(5, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b05.value == 1" @click="switchModel(5, 0)">制热 ☀</div>
        </div>
        <div class="screw-center-titL">
          <span style="color: #28A1FE;">------</span> F4
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b04.value == 0" @click="switchBeng(4, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b04.value == 1" @click="switchBeng(4, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b04.value == 0" @click="switchKong(4, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b04.value == 1" @click="switchKong(4, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b04.value == 0" @click="switchModel(4, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b04.value == 1" @click="switchModel(4, 0)">制热 ☀</div>
        </div>
        <div class="screw-center-tit">
          F3 <span style="color: #28A1FE;">------</span>
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b03.value == 0" @click="switchBeng(3, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b03.value == 1" @click="switchBeng(3, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b03.value == 0" @click="switchKong(3, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b03.value == 1" @click="switchKong(3, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b03.value == 0" @click="switchModel(3, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b03.value == 1" @click="switchModel(3, 0)">制热 ☀</div>
        </div>
        <div class="screw-center-titL">
          <span style="color: #28A1FE;">------</span> F2
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b02.value == 0" @click="switchBeng(2, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b02.value == 1" @click="switchBeng(2, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b02.value == 0" @click="switchKong(2, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b02.value == 1" @click="switchKong(2, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b02.value == 0" @click="switchModel(2, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b02.value == 1" @click="switchModel(2, 0)">制热 ☀</div>
        </div>
        <div class="screw-center-tit">
          F1 <span style="color: #28A1FE;">------</span>
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b01.value == 0" @click="switchBeng(1, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b01.value == 1" @click="switchBeng(1, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b01.value == 0" @click="switchKong(1, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b01.value == 1" @click="switchKong(1, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b01.value == 0" @click="switchModel(1, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b01.value == 1" @click="switchModel(1, 0)">制热 ☀</div>
        </div>
      </div>
      <div class="screw-body-inner-right">
        <div class="screw-right-main11">
          <div ref="pieEleven" style="width: 100%; height: 15vh"></div>
        </div>
        <div class="screw-right-main9">
          <div ref="pieNine" style="width: 100%; height: 15vh"></div>
        </div>
        <div class="screw-right-main7">
          <div ref="pieSeven" style="width: 100%; height: 15vh"></div>
        </div>
        <div class="screw-right-main5">
          <div ref="pieFive" style="width: 100%; height: 15vh"></div>
        </div>
        <div class="screw-right-main3">
          <div ref="pieThree" style="width: 100%; height: 15vh"></div>
        </div>
        <div class="screw-right-main1">
          <div ref="pieOne" style="width: 100%; height: 15vh"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import * as echarts from 'echarts';
import echarts from 'echarts';
import service from '../../service/leftService';
export default {
  name: '',
  props: [''],
  data() {
    return {
      testArray: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',],
      testSize: 0,
      xData1: [],
      xData2: [],
      xData3: [],
      xData4: [],
      xData5: [],
      xData6: [],
      xData7: [],
      xData8: [],
      xData9: [],
      xData10: [],
      xData11: [],
      timer: null,
      timmer: null,
      bengArr: {
        b01: {
          id: '',
          value: 0,
        },
        b02: {
          id: '',
          value: '0',
        },
        b03: {
          id: '',
          value: '0',
        },
        b04: {
          id: '',
          value: '0',
        },
        b05: {
          id: '',
          value: '0',
        },
        b06: {
          id: '',
          value: '0',
        },
        b07: {
          id: '',
          value: '0',
        },
        b08: {
          id: '',
          value: '0',
        },
        b09: {
          id: '',
          value: '0',
        },
        b10: {
          id: '',
          value: '0',
        },
        b11: {
          id: '',
          value: '0',
        },
      },
      kongArr: {
        b01: {
          id: '',
          value: 0,
        },
        b02: {
          id: '',
          value: '0',
        },
        b03: {
          id: '',
          value: '0',
        },
        b04: {
          id: '',
          value: '0',
        },
        b05: {
          id: '',
          value: '0',
        },
        b06: {
          id: '',
          value: '0',
        },
        b07: {
          id: '',
          value: '0',
        },
        b08: {
          id: '',
          value: '0',
        },
        b09: {
          id: '',
          value: '0',
        },
        b10: {
          id: '',
          value: '0',
        },
        b11: {
          id: '',
          value: '0',
        },
      },
      modelArr: {
        b01: {
          id: '',
          value: 0,
        },
        b02: {
          id: '',
          value: '0',
        },
        b03: {
          id: '',
          value: '0',
        },
        b04: {
          id: '',
          value: '0',
        },
        b05: {
          id: '',
          value: '0',
        },
        b06: {
          id: '',
          value: '0',
        },
        b07: {
          id: '',
          value: '0',
        },
        b08: {
          id: '',
          value: '0',
        },
        b09: {
          id: '',
          value: '0',
        },
        b10: {
          id: '',
          value: '0',
        },
        b11: {
          id: '',
          value: '0',
        },
      },
    };
  },

  components: {},

  computed: {},

  beforeMount() { },

  methods: {
    echartsInit() {
      // 获取当前时间戳
      let timestamp = Date.now();
      // F10
      let pieTen = echarts.init(this.$refs.pieTen);
      pieTen.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '25%',
            bottom: '0%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData10,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#006eff', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#006effb1'
                  },
                  {
                    offset: 1,
                    color: '#006eff15'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieTen.resize()
      })
      // F8
      let pieEight = echarts.init(this.$refs.pieEight);
      pieEight.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '25%',
            bottom: '0%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData8,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#006eff', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#006effb1'
                  },
                  {
                    offset: 1,
                    color: '#006eff15'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieEight.resize()
      })
      // F6
      let pieSix = echarts.init(this.$refs.pieSix);
      pieSix.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '25%',
            bottom: '0%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData6,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#006eff', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#006effb1'
                  },
                  {
                    offset: 1,
                    color: '#006eff15'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieSix.resize()
      })
      // F4
      let pieFour = echarts.init(this.$refs.pieFour);
      pieFour.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '25%',
            bottom: '0%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData4,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#006eff', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#006effb1'
                  },
                  {
                    offset: 1,
                    color: '#006eff15'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieFour.resize()
      })
      // F2
      let pieTwo = echarts.init(this.$refs.pieTwo);
      pieTwo.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '28%',
            bottom: '0%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData2,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#006eff', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#006effb1'
                  },
                  {
                    offset: 1,
                    color: '#006eff15'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieTwo.resize()
      })
      // F11
      let pieEleven = echarts.init(this.$refs.pieEleven);
      pieEleven.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '30%',
            bottom: '0%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData11,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#006eff', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#006effb1'
                  },
                  {
                    offset: 1,
                    color: '#006eff15'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieEleven.resize()
      })
      // F9
      let pieNine = echarts.init(this.$refs.pieNine);
      pieNine.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '30%',
            bottom: '0%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData9,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#006eff', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#006effb1'
                  },
                  {
                    offset: 1,
                    color: '#006eff15'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieNine.resize()
      })
      // F7
      let pieSeven = echarts.init(this.$refs.pieSeven);
      pieSeven.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '30%',
            bottom: '0%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData7,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#006eff', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#006effb1'
                  },
                  {
                    offset: 1,
                    color: '#006eff15'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieSeven.resize()
      })
      // F5
      let pieFive = echarts.init(this.$refs.pieFive);
      pieFive.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '30%',
            bottom: '0%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData5,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#006eff', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#006effb1'
                  },
                  {
                    offset: 1,
                    color: '#006eff15'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieFive.resize()
      })
      // F3
      let pieThree = echarts.init(this.$refs.pieThree);
      pieThree.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '30%',
            bottom: '0%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData3,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#006eff', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#006effb1'
                  },
                  {
                    offset: 1,
                    color: '#006eff15'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieThree.resize()
      })
      // F1
      let pieOne = echarts.init(this.$refs.pieOne);
      pieOne.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '30%',
            bottom: '0%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData1,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#006eff', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#006effb1'
                  },
                  {
                    offset: 1,
                    color: '#006eff15'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieOne.resize()
      })
    },
    getTime() {
      let myDate = new Date();
      let house = myDate.getHours();
      let minutes = myDate.getMinutes();
      let second = myDate.getSeconds();
      let time = house + ":" + minutes + ":" + second;
      let obj = {
        "args": ['上海城工功率数据接口']
      }
      service.getPublicData(obj).then(res => {
        if (this.testSize > 900) {
          this.testSize = 920
          this.testArray.shift()
          this.testArray.push(time)
        } else {
          this.testArray.splice(this.testSize, 1, time)
        }
        res.forEach(item => {
          if (item.secondName == 'SHCG_P01') {
            if (this.testSize > 900) {
              this.xData1.shift()
              this.xData1.push(item.value)
            } else {
              this.xData1.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P02') {
            if (this.testSize > 900) {
              this.xData2.shift()
              this.xData2.push(item.value)
            } else {
              this.xData2.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P03') {
            if (this.testSize > 900) {
              this.xData3.shift()
              this.xData3.push(item.value)
            } else {
              this.xData3.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P04') {
            if (this.testSize > 900) {
              this.xData4.shift()
              this.xData4.push(item.value)
            } else {
              this.xData4.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P05') {
            if (this.testSize > 900) {
              this.xData5.shift()
              this.xData5.push(item.value)
            } else {
              this.xData5.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P06') {
            if (this.testSize > 900) {
              this.xData6.shift()
              this.xData6.push(item.value)
            } else {
              this.xData6.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P07') {
            if (this.testSize > 900) {
              this.xData7.shift()
              this.xData7.push(item.value)
            } else {
              this.xData7.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P08') {
            if (this.testSize > 900) {
              this.xData8.shift()
              this.xData8.push(item.value)
            } else {
              this.xData8.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P09') {
            if (this.testSize > 900) {
              this.xData9.shift()
              this.xData9.push(item.value)
            } else {
              this.xData9.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P10') {
            if (this.testSize > 900) {
              this.xData10.shift()
              this.xData10.push(item.value)
            } else {
              this.xData10.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P11') {
            if (this.testSize > 900) {
              this.xData11.shift()
              this.xData11.push(item.value)
            } else {
              this.xData11.push(item.value)
            }
          }
        });
        this.testSize++
        this.echartsInit()
      })
    },
    // 获取循环泵数据
    getData() {
      // 获取循环泵开关数据
      let obj = {
        "args": ['上海城工循环泵开关']
      }
      service.getPublicData(obj).then(res => {
        res.forEach(item => {
          if (item.secondName == 'SHCG_B01') {
            this.bengArr.b01.id = item.id
            if (item.value == 1) {
              this.bengArr.b01.value = 1
            } else {
              this.bengArr.b01.value = 0
            }
          }
          if (item.secondName == 'SHCG_B02') {
            this.bengArr.b02.id = item.id
            if (item.value == 1) {
              this.bengArr.b02.value = 1
            } else {
              this.bengArr.b02.value = 0
            }
          }
          if (item.secondName == 'SHCG_B03') {
            this.bengArr.b03.id = item.id
            if (item.value == 1) {
              this.bengArr.b03.value = 1
            } else {
              this.bengArr.b03.value = 0
            }
          }
          if (item.secondName == 'SHCG_B04') {
            this.bengArr.b04.id = item.id
            if (item.value == 1) {
              this.bengArr.b04.value = 1
            } else {
              this.bengArr.b04.value = 0
            }
          }
          if (item.secondName == 'SHCG_B05') {
            this.bengArr.b05.id = item.id
            if (item.value == 1) {
              this.bengArr.b05.value = 1
            } else {
              this.bengArr.b05.value = 0
            }
          }
          if (item.secondName == 'SHCG_B06') {
            this.bengArr.b06.id = item.id
            if (item.value == 1) {
              this.bengArr.b06.value = 1
            } else {
              this.bengArr.b06.value = 0
            }
          }
          if (item.secondName == 'SHCG_B07') {
            this.bengArr.b07.id = item.id
            if (item.value == 1) {
              this.bengArr.b07.value = 1
            } else {
              this.bengArr.b07.value = 0
            }
          }
          if (item.secondName == 'SHCG_B08') {
            this.bengArr.b08.id = item.id
            if (item.value == 1) {
              this.bengArr.b08.value = 1
            } else {
              this.bengArr.b08.value = 0
            }
          }
          if (item.secondName == 'SHCG_B09') {
            this.bengArr.b09.id = item.id
            if (item.value == 1) {
              this.bengArr.b09.value = 1
            } else {
              this.bengArr.b09.value = 0
            }
          }
          if (item.secondName == 'SHCG_B10') {
            this.bengArr.b10.id = item.id
            if (item.value == 1) {
              this.bengArr.b10.value = 1
            } else {
              this.bengArr.b10.value = 0
            }
          }
          if (item.secondName == 'SHCG_B11') {
            this.bengArr.b11.id = item.id
            if (item.value == 1) {
              this.bengArr.b11.value = 1
            } else {
              this.bengArr.b11.value = 0
            }
          }

        })
      })
    },
    // 空调数据接口
    getDataKong() {
      let obj = {
        "args": ['上海城工空调数据接口']
      }
      service.getPublicData(obj).then(res => {
        res.forEach(item => {
          if (item.secondName == 'SHCG_K01') {
            this.kongArr.b01.id = item.id
            if (item.value == 1) {
              this.kongArr.b01.value = 1
            } else {
              this.kongArr.b01.value = 0
            }
          }
          if (item.secondName == 'SHCG_K02') {
            this.kongArr.b02.id = item.id
            if (item.value == 1) {
              this.kongArr.b02.value = 1
            } else {
              this.kongArr.b02.value = 0
            }
          }
          if (item.secondName == 'SHCG_K03') {
            this.kongArr.b03.id = item.id
            if (item.value == 1) {
              this.kongArr.b03.value = 1
            } else {
              this.kongArr.b03.value = 0
            }
          }
          if (item.secondName == 'SHCG_K04') {
            this.kongArr.b04.id = item.id
            if (item.value == 1) {
              this.kongArr.b04.value = 1
            } else {
              this.kongArr.b04.value = 0
            }
          }
          if (item.secondName == 'SHCG_K05') {
            this.kongArr.b05.id = item.id
            if (item.value == 1) {
              this.kongArr.b05.value = 1
            } else {
              this.kongArr.b05.value = 0
            }
          }
          if (item.secondName == 'SHCG_K06') {
            this.kongArr.b06.id = item.id
            if (item.value == 1) {
              this.kongArr.b06.value = 1
            } else {
              this.kongArr.b06.value = 0
            }
          }
          if (item.secondName == 'SHCG_K07') {
            this.kongArr.b07.id = item.id
            if (item.value == 1) {
              this.kongArr.b07.value = 1
            } else {
              this.kongArr.b07.value = 0
            }
          }
          if (item.secondName == 'SHCG_K08') {
            this.kongArr.b08.id = item.id
            if (item.value == 1) {
              this.kongArr.b08.value = 1
            } else {
              this.kongArr.b08.value = 0
            }
          }
          if (item.secondName == 'SHCG_K09') {
            this.kongArr.b09.id = item.id
            if (item.value == 1) {
              this.kongArr.b09.value = 1
            } else {
              this.kongArr.b09.value = 0
            }
          }
          if (item.secondName == 'SHCG_K10') {
            this.kongArr.b10.id = item.id
            if (item.value == 1) {
              this.kongArr.b10.value = 1
            } else {
              this.kongArr.b10.value = 0
            }
          }
          if (item.secondName == 'SHCG_K11') {
            this.kongArr.b11.id = item.id
            if (item.value == 1) {
              this.kongArr.b11.value = 1
            } else {
              this.kongArr.b11.value = 0
            }
          }

        })
      })
    },
    // 模式数据接口
    getDataModel() {
      let obj = {
        "args": ['上海城工模式数据接口']
      }
      service.getPublicData(obj).then(res => {
        res.forEach(item => {
          if (item.secondName == 'SHCG_M01') {
            this.modelArr.b01.id = item.id
            if (item.value == 1) {
              this.modelArr.b01.value = 1
            } else {
              this.modelArr.b01.value = 0
            }
          }
          if (item.secondName == 'SHCG_M02') {
            this.modelArr.b02.id = item.id
            if (item.value == 1) {
              this.modelArr.b02.value = 1
            } else {
              this.modelArr.b02.value = 0
            }
          }
          if (item.secondName == 'SHCG_M03') {
            this.modelArr.b03.id = item.id
            if (item.value == 1) {
              this.modelArr.b03.value = 1
            } else {
              this.modelArr.b03.value = 0
            }
          }
          if (item.secondName == 'SHCG_M04') {
            this.modelArr.b04.id = item.id
            if (item.value == 1) {
              this.modelArr.b04.value = 1
            } else {
              this.modelArr.b04.value = 0
            }
          }
          if (item.secondName == 'SHCG_M05') {
            this.modelArr.b05.id = item.id
            if (item.value == 1) {
              this.modelArr.b05.value = 1
            } else {
              this.modelArr.b05.value = 0
            }
          }
          if (item.secondName == 'SHCG_M06') {
            this.modelArr.b06.id = item.id
            if (item.value == 1) {
              this.modelArr.b06.value = 1
            } else {
              this.modelArr.b06.value = 0
            }
          }
          if (item.secondName == 'SHCG_M07') {
            this.modelArr.b07.id = item.id
            if (item.value == 1) {
              this.modelArr.b07.value = 1
            } else {
              this.modelArr.b07.value = 0
            }
          }
          if (item.secondName == 'SHCG_M08') {
            this.modelArr.b08.id = item.id
            if (item.value == 1) {
              this.modelArr.b08.value = 1
            } else {
              this.modelArr.b08.value = 0
            }
          }
          if (item.secondName == 'SHCG_M09') {
            this.modelArr.b09.id = item.id
            if (item.value == 1) {
              this.modelArr.b09.value = 1
            } else {
              this.modelArr.b09.value = 0
            }
          }
          if (item.secondName == 'SHCG_M10') {
            this.modelArr.b10.id = item.id
            if (item.value == 1) {
              this.modelArr.b10.value = 1
            } else {
              this.modelArr.b10.value = 0
            }
          }
          if (item.secondName == 'SHCG_M11') {
            this.modelArr.b11.id = item.id
            if (item.value == 1) {
              this.modelArr.b11.value = 1
            } else {
              this.modelArr.b11.value = 0
            }
          }

        })
      })
    },
    // 水泵开关
    switchBeng(h, val) {
      if (h == 1) {
        this.bengArr.b01.value = val
        this.updateData(this.bengArr.b01)
      }
      if (h == 2) {
        this.bengArr.b02.value = val
        this.updateData(this.bengArr.b02)
      }
      if (h == 3) {
        this.bengArr.b03.value = val
        this.updateData(this.bengArr.b03)
      }
      if (h == 4) {
        this.bengArr.b04.value = val
        this.updateData(this.bengArr.b04)
      }
      if (h == 5) {
        this.bengArr.b05.value = val
        this.updateData(this.bengArr.b05)
      }
      if (h == 6) {
        this.bengArr.b06.value = val
        this.updateData(this.bengArr.b06)
      }
      if (h == 7) {
        this.bengArr.b07.value = val
        this.updateData(this.bengArr.b07)
      }
      if (h == 8) {
        this.bengArr.b08.value = val
        this.updateData(this.bengArr.b08)
      }
      if (h == 9) {
        this.bengArr.b09.value = val
        this.updateData(this.bengArr.b09)
      }
      if (h == 10) {
        this.bengArr.b10.value = val
        this.updateData(this.bengArr.b10)
      }
      if (h == 11) {
        this.bengArr.b11.value = val
        this.updateData(this.bengArr.b11)
      }
    },
    // 空调开关切换
    switchKong(h, val) {
      if (h == 1) {
        this.kongArr.b01.value = val
        this.updateData(this.kongArr.b01)
      }
      if (h == 2) {
        this.kongArr.b02.value = val
        this.updateData(this.kongArr.b02)
      }
      if (h == 3) {
        this.kongArr.b03.value = val
        this.updateData(this.kongArr.b03)
      }
      if (h == 4) {
        this.kongArr.b04.value = val
        this.updateData(this.kongArr.b04)
      }
      if (h == 5) {
        this.kongArr.b05.value = val
        this.updateData(this.kongArr.b05)
      }
      if (h == 6) {
        this.kongArr.b06.value = val
        this.updateData(this.kongArr.b06)
      }
      if (h == 7) {
        this.kongArr.b07.value = val
        this.updateData(this.kongArr.b07)
      }
      if (h == 8) {
        this.kongArr.b08.value = val
        this.updateData(this.kongArr.b08)
      }
      if (h == 9) {
        this.kongArr.b09.value = val
        this.updateData(this.kongArr.b09)
      }
      if (h == 10) {
        this.kongArr.b10.value = val
        this.updateData(this.kongArr.b10)
      }
      if (h == 11) {
        this.kongArr.b11.value = val
        this.updateData(this.kongArr.b11)
      }
    },
    // 模式开关切换
    switchModel(h, val) {
      if (h == 1) {
        this.modelArr.b01.value = val
        this.updateData(this.modelArr.b01)
      }
      if (h == 2) {
        this.modelArr.b02.value = val
        this.updateData(this.modelArr.b02)
      }
      if (h == 3) {
        this.modelArr.b03.value = val
        this.updateData(this.modelArr.b03)
      }
      if (h == 4) {
        this.modelArr.b04.value = val
        this.updateData(this.modelArr.b04)
      }
      if (h == 5) {
        this.modelArr.b05.value = val
        this.updateData(this.modelArr.b05)
      }
      if (h == 6) {
        this.modelArr.b06.value = val
        this.updateData(this.modelArr.b06)
      }
      if (h == 7) {
        this.modelArr.b07.value = val
        this.updateData(this.modelArr.b07)
      }
      if (h == 8) {
        this.modelArr.b08.value = val
        this.updateData(this.modelArr.b08)
      }
      if (h == 9) {
        this.modelArr.b09.value = val
        this.updateData(this.modelArr.b09)
      }
      if (h == 10) {
        this.modelArr.b10.value = val
        this.updateData(this.modelArr.b10)
      }
      if (h == 11) {
        this.modelArr.b11.value = val
        this.updateData(this.modelArr.b11)
      }
    },
    // 修改数据
    updateData(obj) {
      service.updatePhysicalPoint(obj).then(res => {
        this.$message.success('切换成功')
      }).catch(err => {
        this.$message.error('切换失败')
      })
    }
  },

  watch: {},

  mounted() {
    this.timer = setInterval(() => {
      this.getTime()
    }, 1000)
    this.getData()
    this.getDataKong()
    this.getDataModel()
  },
  destroyed() {
    clearInterval(this.timer)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}

</script>
<style lang='scss' scoped>
.screw-body {
  width: 100%;
  height: 100%;
  background: url('../../../static/img/sicon/screw001.png') no-repeat;
  background-size: 100% 100%;
  overflow: hidden;

  .screw-body-inner {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .screw-body-inner-left {
      width: 38%;
      height: 100%;

      .screw-left-logo {
        width: 100%;
        height: 7.5vh;
        background-image: url('../../../static/img/sicon/screw002.png');
        background-size: 100% 100%;
      }

      .screw-left-body {
        width: 100%;
        height: calc(100% - 7.5vh);
        box-sizing: border-box;
        padding-left: 5vh;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-wrap: wrap;
        overflow: hidden;

        .screw-left-main10 {
          width: 100%;
          height: 17vh;
          background-image: url('../../../static/img/sicon/screw10.png');
          background-size: 100% 100%;
        }

        .screw-left-main8 {
          width: 100%;
          height: 17vh;
          background-image: url('../../../static/img/sicon/screw8.png');
          background-size: 100% 100%;
        }

        .screw-left-main6 {
          width: 100%;
          height: 17vh;
          background-image: url('../../../static/img/sicon/screw6.png');
          background-size: 100% 100%;
        }

        .screw-left-main4 {
          width: 100%;
          height: 17vh;
          background-image: url('../../../static/img/sicon/screw4.png');
          background-size: 100% 100%;
        }

        .screw-left-main2 {
          width: 100%;
          height: 17vh;
          background-image: url('../../../static/img/sicon/screw2.png');
          background-size: 100% 100%;
        }
      }
    }

    .screw-body-inner-center {
      width: 23%;
      height: 100%;
      box-sizing: border-box;
      padding: 8px 0px 0px 0px;

      .screw-center-tit {
        width: 100%;
        height: 3vh;
        text-align: right;
        color: #FFFFFF;
        font-size: 1.5vh;
        font-weight: 800;
      }

      .screw-center-titL {
        width: 100%;
        height: 3vh;
        text-align: left;
        color: #FFFFFF;
        font-size: 1.5vh;
        font-weight: 800;
      }

      .screw-center-btn {
        width: 100%;
        height: 6vh;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0px 20px 0px 20px;

        .screw-btn-box {
          width: 27%;
          height: 90%;
          cursor: pointer;
          color: #FFFFFF;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 1.5vh;
          font-weight: 800
        }

        .screw-btn-cool {
          width: 15%;
          height: 1.8vh;
          background-image: url('../../../static/img/sicon/zhileng.png');
          background-size: 100% 100%;
          margin-left: 4%;
        }

        .screw-btn-hot {
          width: 15%;
          height: 1.8vh;
          background-image: url('../../../static/img/sicon/zhire.png');
          background-size: 100% 100%;
          margin-left: 4%;
        }
      }
    }

    .screw-body-inner-right {
      width: 38%;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      box-sizing: border-box;

      .screw-right-main11 {
        width: 92%;
        height: 16vh;
        background-image: url('../../../static/img/sicon/screw11.png');
        background-size: 100% 100%
      }

      .screw-right-main9 {
        width: 92%;
        height: 16vh;
        background-image: url('../../../static/img/sicon/screw9.png');
        background-size: 100% 100%
      }

      .screw-right-main7 {
        width: 92%;
        height: 16vh;
        background-image: url('../../../static/img/sicon/screw7.png');
        background-size: 100% 100%
      }

      .screw-right-main5 {
        width: 92%;
        height: 16vh;
        background-image: url('../../../static/img/sicon/screw5.png');
        background-size: 100% 100%
      }

      .screw-right-main3 {
        width: 92%;
        height: 16vh;
        background-image: url('../../../static/img/sicon/screw3.png');
        background-size: 100% 100%
      }

      .screw-right-main1 {
        width: 92%;
        height: 16vh;
        background-image: url('../../../static/img/sicon/screw1.png');
        background-size: 100% 100%
      }
    }
  }
}

.btn-on1 {
  background-image: url('../../../static/img/sicon/screwBtn01.png');
  background-size: 100% 100%;
}

.btn-on2 {
  background-image: url('../../../static/img/sicon/serwchBtn02.png');
  background-size: 100% 100%;
}

.btn-on3 {
  background-image: url('../../../static/img/sicon/screwBtn03.png');
  background-size: 100% 100%;
}

.btn-on4 {
  background-image: url('../../../static/img/sicon/screwBtn04.png');
  background-size: 100% 100%;
  color: #006effb1;
}
</style>



// WEBPACK FOOTER //
// src/components/graphically/screwShow.vue